import React, { FormEvent, LegacyRef } from 'react';
import TabPanel from '../../../components/TabPanel/TabPanel';
import { Tabs, Tab, Button, TextField } from '@material-ui/core';
import NumberFormat from 'react-number-format';
import { IonSpinner } from '@ionic/react';
import QRCode from 'react-qr-code';
import phonePe from '../../../assets/images/common/icons/phonepay.svg';
import bank from '../../../assets/images/common/icons/bank.svg';
import gpay from '../../../assets/images/common/icons/gpay.svg';
import paytm from '../../../assets/images/common/icons/paytm.svg';
import ContentCopy from '../../../assets/images/sportsbook/icons/copy-content.svg';
import { AccountDetails } from '../AccountDetails';

interface PgmanProps {
  tabValue: number | string;
  paymentOption: string;
  setPaymentOption: (paymentOption: string) => void;
  accountDetails: AccountDetails[];
  selectedAccountId: string;
  setSelectedAccountId: (accountId: string) => void;
  selectedAccount: AccountDetails;
  setSelectedAccount: (acc: AccountDetails) => void;
  copyText: (text: string) => void;
  paymentOptionFilter: string;
  setPaymentOptionFilter: (paymentOption: string) => void;
  submitPayment: (event: React.FormEvent<HTMLFormElement>) => Promise<boolean>;
  depositAmount: string;
  setDepositAmount: (amount: string) => void;
  referenceId: string;
  setReferenceId: (referenceId: string) => void;
  depositNotes: string;
  setDepositNotes: (depositNotes: string) => void;
  depositImage: string | ArrayBuffer;
  setDepositImage?: (image: string | ArrayBuffer) => void;
  handleCapture: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleClick: () => void;
  loading: boolean;
  index: number | string;
}

const Pgman = React.forwardRef<HTMLInputElement, PgmanProps>(
  (
    {
      tabValue,
      paymentOption,
      setPaymentOption,
      accountDetails,
      selectedAccountId,
      setSelectedAccountId,
      setSelectedAccount,
      selectedAccount,
      copyText,
      paymentOptionFilter,
      setPaymentOptionFilter,
      submitPayment,
      depositAmount,
      depositNotes,
      referenceId,
      setDepositAmount,
      setDepositNotes,
      setReferenceId,
      depositImage,
      handleCapture,
      handleClick,
      loading,
      index,
    },
    hiddenFileInput
  ) => {
    return (
      <TabPanel value={tabValue} index={index} className="payment-options">
        <div className="payment-option-title mt-10">Choose Payment Option</div>
        <Button
          className={
            paymentOption === 'NEFT' ? 'active payment-btn' : 'payment-btn'
          }
          onClick={() => setPaymentOption('NEFT')}
        >
          <img
            className={'payment-icon'}
            alt="bank"
            src={bank}
            loading="lazy"
          />
        </Button>
        <Button
          className={
            paymentOption === 'GPAY' ? 'active payment-btn' : 'payment-btn'
          }
          onClick={() => setPaymentOption('GPAY')}
        >
          <img
            className={'payment-icon'}
            alt="gpay"
            src={gpay}
            loading="lazy"
          />
        </Button>
        <Button
          className={
            paymentOption === 'PHONEPE' ? 'active payment-btn' : 'payment-btn'
          }
          onClick={() => setPaymentOption('PHONEPE')}
        >
          <img
            className={'payment-icon'}
            alt="phonepay"
            src={phonePe}
            loading="lazy"
          />
        </Button>
        <Button
          className={
            paymentOption === 'PAYTM_WALLET'
              ? 'active payment-btn'
              : 'payment-btn'
          }
          onClick={() => setPaymentOption('PAYTM_WALLET')}
        >
          <img
            className={'payment-icon'}
            alt="paytm"
            src={paytm}
            loading="lazy"
            height={30}
          />
        </Button>

        <div>
          {accountDetails?.length > 0 ? (
            <>
              {/* <div className="payment-form-divider"></div> */}
              <div className="account-details-title account-mt-10">
                Choose Beneficiary Account
              </div>
            </>
          ) : null}
          {paymentOption && accountDetails?.length == 0 ? (
            <>
              <div className="account-details-title account-mt-10">
                No Beneficiary Account Available
              </div>
            </>
          ) : null}
          <div className="account-details-ctn">
            <Tabs
              value={1}
              variant="scrollable"
              scrollButtons="off"
              className="actions-list"
            >
              {accountDetails?.map((acc) =>
                !acc?.disabled ? (
                  <div className="btn-and-qrcode">
                    <Button
                      className={
                        acc?.id?.toString() === selectedAccountId
                          ? 'active account-detail'
                          : 'account-detail'
                      }
                      onClick={() => {
                        setSelectedAccountId(acc?.id?.toString());
                        setSelectedAccount(acc);
                      }}
                    >
                      <div className="account">
                        <div className="account-name">
                          {acc?.paymentMethodDetails?.accountHolderName}
                        </div>
                      </div>
                    </Button>
                  </div>
                ) : null
              )}
            </Tabs>
          </div>
        </div>

        {!selectedAccount?.disabled ? (
          <div className="btn-and-qrcode">
            <div className={'account-detail'}>
              <div className="account">
                <div>
                  {selectedAccount?.paymentMethodDetails?.accountHolderName}{' '}
                </div>

                {selectedAccount?.paymentMethodDetails?.accountHolderName ? (
                  <div
                    className="copy-btn"
                    onClick={(e) => {
                      copyText(
                        selectedAccount?.paymentMethodDetails?.accountHolderName
                      );
                      e.stopPropagation();
                    }}
                  >
                    <img className="content-copy" src={ContentCopy} />
                  </div>
                ) : null}
              </div>
              <div className="account">
                <div>
                  {selectedAccount?.paymentMethodDetails?.accountNumber}
                </div>
                {selectedAccount?.paymentMethodDetails?.accountNumber ? (
                  <div
                    className="copy-btn"
                    onClick={(e) => {
                      copyText(
                        selectedAccount?.paymentMethodDetails?.accountNumber
                      );
                      e.stopPropagation();
                    }}
                  >
                    <img className="content-copy" src={ContentCopy} />
                  </div>
                ) : null}
              </div>
              <div className="account">
                <div>{selectedAccount?.paymentMethodDetails?.upiId}</div>
                {selectedAccount?.paymentMethodDetails?.upiId ? (
                  <div
                    className="copy-btn"
                    onClick={(e) => {
                      copyText(selectedAccount?.paymentMethodDetails?.upiId);
                      e.stopPropagation();
                    }}
                  >
                    <img className="content-copy" src={ContentCopy} alt="" />
                  </div>
                ) : null}
              </div>
              <div className="account">
                <div>{selectedAccount?.paymentMethodDetails?.phoneNumber}</div>
                {selectedAccount?.paymentMethodDetails?.phoneNumber ? (
                  <div
                    className="copy-btn"
                    onClick={(e) => {
                      copyText(
                        selectedAccount?.paymentMethodDetails?.phoneNumber
                      );
                      e.stopPropagation();
                    }}
                  >
                    <img className="content-copy" src={ContentCopy} alt="" />
                  </div>
                ) : null}
              </div>
              {paymentOption === 'NEFT' && (
                <div className="account-ifsc account">
                  <div>
                    {selectedAccount?.paymentMethodDetails?.ifscCode
                      ? `IFSC: ${selectedAccount?.paymentMethodDetails?.ifscCode}`
                      : null}
                  </div>
                  {selectedAccount?.paymentMethodDetails?.ifscCode ? (
                    <div
                      className="copy-btn"
                      onClick={(e) => {
                        copyText(
                          selectedAccount?.paymentMethodDetails?.ifscCode
                        );
                        e.stopPropagation();
                      }}
                    >
                      <img className="content-copy" src={ContentCopy} alt="" />
                    </div>
                  ) : null}
                </div>
              )}
            </div>

            {selectedAccount?.paymentMethodDetails?.upiId && (
              <div>
                <div>
                  <div
                    style={{
                      height: 'auto',
                      margin: '0px',
                      maxWidth: 128,
                      width: '100%',
                    }}
                  >
                    <QRCode
                      size={256}
                      style={{
                        height: 'auto',
                        maxWidth: '100%',
                        width: '100%',
                      }}
                      value={`upi://pay?pa=${selectedAccount?.paymentMethodDetails?.upiId}&tn=pay to eswar&cu=INR&pn=${selectedAccount?.paymentMethodDetails?.accountHolderName}`}
                      viewBox={`0 0 256 256`}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : null}

        {selectedAccountId ? (
          <>
            <div className="payment-form-divider"></div>

            <form className="account-inputs" onSubmit={(e) => submitPayment(e)}>
              <div className="account-input-title">Enter Payment Details</div>

              {paymentOption === 'NEFT' ? (
                <div className="account-input">
                  <div className="account-label">Select Payment Option</div>
                  <select
                    required
                    value={paymentOptionFilter}
                    placeholder="Select One"
                    className="acc-input"
                    onChange={(e) => setPaymentOptionFilter(e.target.value)}
                  >
                    <option value="IMPS">IMPS</option>
                    <option value="NEFT">NEFT</option>
                    <option value="RTGS">RTGS</option>
                  </select>
                </div>
              ) : null}

              <div className="account-input">
                <div className="account-label">
                  Enter Amount (Re-verify for correctness)
                </div>
                <NumberFormat
                  required
                  className="acc-input"
                  placeholder="Enter Deposited Amount"
                  value={depositAmount}
                  onChange={(e) => setDepositAmount(e.target.value)}
                  decimalSeparator={false}
                />
              </div>

              <div className="account-input">
                <div className="account-label">
                  Enter Reference ID (Re-verify for correctness)
                </div>
                <TextField
                  required
                  placeholder="Enter Transaction Reference ID"
                  className="acc-input"
                  value={referenceId}
                  onChange={(e) => setReferenceId(e.target.value)}
                />
              </div>

              <div className="account-input">
                <div className="account-label">Enter Notes</div>
                <TextField
                  placeholder="Enter Notes"
                  className="acc-input"
                  value={depositNotes}
                  onChange={(e) => setDepositNotes(e.target.value)}
                />
              </div>

              <div className="account-input">
                {depositImage ? (
                  <>
                    <div>
                      <div className="uploaded-image-title">Uploaded Image</div>
                      <img src={`${depositImage}`} className="deposit-image" />
                    </div>
                  </>
                ) : null}

                <input
                  accept="image/*"
                  style={{ display: 'none' }}
                  id="raised-button-file-pgman"
                  multiple
                  hidden
                  type="file"
                  ref={hiddenFileInput}
                  onChange={(e) => handleCapture(e)}
                />
                <Button
                  component="div"
                  className="upload-btn"
                  onClick={handleClick}
                >
                  Upload Image
                </Button>
              </div>
              <Button
                className="submit-payment-btn"
                type="submit"
                disabled={loading ? true : false}
                endIcon={loading ? <IonSpinner name="lines-small" /> : ''}
              >
                Submit
              </Button>
            </form>
          </>
        ) : null}
      </TabPanel>
    );
  }
);

export default Pgman;
